import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import RegistrationTermsModal from './components/RegistrationTermsModal';

// SignUpModal is never a plain top-level import anywhere in core - every
// call site opens it via a lazy `() => import(/* webpackChunkName: 'forum/SignUpModal', webpackMode: 'lazy-once' */ './SignUpModal')` (see
// HeaderSecondary.js and LogInModal.tsx), so it's a separate webpack chunk
// that isn't necessarily loaded yet when this extension's own bundle first
// runs. extend() supports exactly this case: passed a string path instead
// of a prototype, it defers patching until the module actually loads
// (flarum.reg.onLoad internally) instead of dereferencing `.prototype` on
// a class that might still be undefined at boot time.
const SIGN_UP_MODAL = 'flarum/forum/components/SignUpModal';

/**
 * Gates SignUpModal behind the forum rules, matching champis.net's own
 * registration flow: the very first thing oninit does (before anything
 * renders) is swap itself out for RegistrationTermsModal, passing along
 * this exact class and attrs so accepting can re-open the real form
 * afterwards (see that component). champisTermsAccepted on attrs is how
 * that re-open tells this hook "let it render normally this time" -
 * without it, accepting would just show the gate again forever.
 *
 * setTimeout is required here, not incidental: app.modal.show()'s own docs
 * call out that calling it from a lifecycle method like oninit needs this
 * exact wrapping, due to how Mithril handles nested redraws.
 *
 * Overriding the modal itself - rather than intercepting every place that
 * calls `app.modal.show(SignUpModal, ...)` (HeaderSecondary, LogInModal's
 * "create an account" link, ...) - means every entry point gets the gate
 * automatically, including any added by other extensions.
 */
export default function addRegistrationTerms() {
  extend(SIGN_UP_MODAL, 'oninit', function () {
    if (this.attrs.champisTermsAccepted) return;
    const signUpModal = this.constructor;
    const signUpAttrs = this.attrs;
    setTimeout(() => {
      app.modal.show(RegistrationTermsModal, {
        signUpModal,
        signUpAttrs
      });
    });
  });
}